import React from 'react';
import { Seo } from '../components/Seo';
import { pageSeo } from '../data/seo';
import { homeJsonLd } from '../data/structuredData';
import { Hero } from '../components/home/Hero';
import { Breakthroughs } from '../components/home/Breakthroughs';
import { WhatIsIt } from '../components/home/WhatIsIt';
import { ShopPreview } from '../components/home/ShopPreview';
import { SavingsCard } from '../components/home/SavingsCard';
import { HowItWorks } from '../components/HowItWorks';
import { ComparisonTable } from '../components/ComparisonTable';
import { Testimonials } from '../components/Testimonials';
import { TaxNotice } from '../components/home/TaxNotice';
import { Mission } from '../components/home/Mission';
import { FaqSection } from '../components/FaqSection';
import { TextCta } from '../components/TextCta';
export function Home() {
  return <main data-id="element-301" data-mp="3kv0ox6qnoitj">
      <Seo {...pageSeo.home} jsonLd={homeJsonLd} data-id="element-302" data-mp="3kxd276lgy509" />
      <Hero data-id="element-303" data-mp="3ow403fxrdqof" />
      <Breakthroughs data-id="element-304" data-mp="3ovki5z83z2ae" />
      <WhatIsIt data-id="element-305" data-mp="3ov2hmqeey1wo" />
      <ShopPreview data-id="element-306" data-mp="3oyqarofy4mav" />
      <SavingsCard data-id="element-307" data-mp="30wjfqyjbda93" />
      <HowItWorks data-id="element-308" data-mp="30vqdoavav8xa" />
      <ComparisonTable data-id="element-309" data-mp="30w9lgyr8kgxl" />
      <Testimonials data-id="element-310" data-mp="30uoz3wf2s4at" />
      <TaxNotice data-id="element-311" data-mp="2vxyagkp7g0ds" />
      <Mission data-id="element-312" data-mp="2vxf3u0508yf2" />
      <FaqSection data-id="element-313" data-mp="2vyq4vs72fs2h" />
      <TextCta data-id="element-314" data-mp="2vyhty5ui6wtx" />
    </main>;
}